import React,{useEffect} from 'react'
import { Container } from '@mui/material'
import { useState } from 'react';
import {NoteContext} from '../context/note-context';
import { Header } from '../../shared/components/Header'
import {Grid } from '@mui/material';
import SideBar from '../components/SideBar';
import Main from '../components/Main';
import { useLocation } from 'react-router-dom';
import getNotes from '../../shared/services/api-client';
export const NoteDashBoard = () => {
  const location= useLocation();
  console.log(location );
  const addnote=(noteObject)=>{
    console.log('Rec Note from Add',noteObject);
    const cloneNotes=[notes];
    cloneNotes.push(noteObject);
    setNotes(cloneNotes);
    } 
  const [notes,setNotes]=useState([]);
  if(location && location.state){
    localStorage.setItem('username',location.state.username)
  }
  
   const getDataFromAPI= async ()=>{
    const notes= await getNotes();
     setNotes(notes);
    console.log('All Notes are',notes);
     }
    //Mounting
    useEffect(()=>{
    console.log('mounting Code...');
    getDataFromAPI();
    },[]);
  return (
    <Container>
        <Header username={localStorage.getItem('username')} />
        <Grid container spacing={2}>
  <Grid item xs={2}>
  <SideBar/>
  </Grid>
  <Grid item xs={10}>
  <NoteContext.Provider value={{notes:notes, addSingleNote:addnote}}>
<Main/>
</NoteContext.Provider>

  </Grid>
  
</Grid>
    </Container>
  )
}
